import { Api } from "@/api";
import { AdminType, UserLoginType } from "@/DTO";
import { ConvertToRoleListType } from "@/api/auth";

export const GetAdminById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: AdminType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `admin/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToAdminType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToAdminType = (item: any): AdminType => {
  return {
    id: item.id,
    first_name: item?.first_name,
    last_name: item?.last_name,
    phone: item?.phone,
    status: item?.status,
    permissions: item?.permissions,
    role: item.role ? ConvertToRoleListType(item.role) : undefined,
    created_at: item?.created_at
  };
};

